<!--操作管日志-->
<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form layout="inline" :form="form" :colon="false">
          <!-- <a-form-item label="操作人">
            <a-input v-decorator="['userName']" placeholder="请输入操作人姓名"></a-input>
          </a-form-item> -->
          <a-form-item label="内容">
            <a-input v-decorator="['search']" placeholder="请输入内容"></a-input>
          </a-form-item>
          <a-form-item label="操作时间">
            <a-range-picker v-decorator="['time', { initialValue: [] }]" allowClear />
          </a-form-item>
        </a-form>

        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">操作日志</div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          :rowKey="(record, index)=>{return index}"
          bordered
          :loading="tableLoading"
          :scroll="{ x: 1400 }"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '5%',
        align: 'center',
        customRender: (text, row, index) => {
          return <span> {this.pageSize * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '操作人',
        width: '15%',
        align: 'center',
        dataIndex: 'nickname',
      },
      {
        title: '操作时间',
        width: '20%',
        align: 'center',
        dataIndex: 'createTime',
      },
      {
        title: '操作内容',
        width: '60%',

        align: 'center',
        customRender: (text, row) => {
          return <span>{row.description}</span>
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      dataSource: [],
      time: [],
    }
  },
  computed: {
    typesMap() {
      return {
        operateType: [
          { label: '新增', value: 1 },
          { label: '修改', value: 2 },
          { label: '编辑', value: 3 },
          { label: '删除', value: 4 },
        ],
      }
    },
  },
  components: {
    Page,
  },
  mounted() {
    this.doQuery()
  },
  methods: {
    resetAndQuery() {
      this.time = []
      this.checkedList = []
      this.resetAndQuery$qv()
    },
    getParams() {
      const params = this.form.getFieldsValue()
      return {
        search: params.search,
        startTime: params.time[0] ? `${params.time[0].format('YYYY-MM-DD')} 00:00:00` : '',
        endTime: params.time[1] ? `${params.time[1].format('YYYY-MM-DD')} 23:59:59` : '',
      }
    },
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const res = await this.$axios.get('/user/admin/operation/log', {
          params: {
            ...this.getParams(),
            page: _pageNumber,
            limit: _pageSize,
          },
        })
        this.countTotal = Number(res.count)
        this.dataSource = res.data
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
  },
}
</script>

<style lang="less" scoped></style>
